<template>
  <v-card>
    <v-layout>
      <v-app-bar title="ONEPLAN Админка"></v-app-bar>

      <Navigation />

      <v-main style="min-height: 100vh">
        <v-container fluid>
          <v-card>
            <v-card-text>
              <SubcategoryTagEdit />
            </v-card-text>
          </v-card>
        </v-container>
      </v-main>
    </v-layout>
  </v-card>
</template>
<script>
import Navigation from "@/components/Navigation";
import SubcategoryTagEdit from "@/components/SubcategoryTag/SubcategoryTagEdit";
export default {
  components: {
    Navigation,
    SubcategoryTagEdit,
  },
};
</script>
